/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";
import * as stagesCase from "../../Stages/StagesCase";
import { CivilServiceLaw } from "../../../types/Products/AdministrativeLaw/CivilServiceLaw/CivilServiceLaw";

export const civilServiceLawRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (product: CivilServiceLaw) => {
    const requiredFields = abstractLitigationCaseRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](product);

    return requiredFields.filter((field) => field !== "extrajudicialCommunicationDeadline");
  },
  [stagesCase.STAGE_CHECKED]: (product: CivilServiceLaw) => {
    const requiredFields = abstractLitigationCaseRequiredFields[stagesCase.STAGE_CHECKED](product);

    return requiredFields.filter((field) => field !== "extrajudicialCommunicationDeadline");
  },
  [stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]: (product: CivilServiceLaw) => {
    const requiredFields =
      abstractLitigationCaseRequiredFields[stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT](product);

    return requiredFields.filter((field) => field !== "extrajudicialCommunicationDeadline");
  },
  [stagesCase.STAGE_PREPARE_LAWSUIT]: (product: CivilServiceLaw) => {
    if (product.administrativeCaseType === "main") {
      return abstractLitigationCaseRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](product);
    }

    return ["valueInDisputeJudicialPreliminary"];
  },
};
